import { createSlice } from '@reduxjs/toolkit'

interface EonInitialState {
  startDate: string
  endDate: string
}

const initialState: EonInitialState = {
  startDate: '',
  endDate: ''
}

const gygEonSlice = createSlice({
  name: 'getAllEon',
  initialState,
  reducers: {
    setStartDate(state, action) {
      state.startDate = action.payload
    },
    setEndDate(state, action) {
      state.endDate = action.payload
    }
  }
})

export const { setStartDate, setEndDate } = gygEonSlice.actions

export default gygEonSlice.reducer
